import {marked} from 'marked';

export interface FetchResult {
	markdown: string;
	text: string;
}

export async function fetchAndParse(url: string): Promise<FetchResult | undefined> {
	try {
		const response = await fetch(url);
		const responseText = await response.text();
		const markdown = marked.parse(responseText);
		const element = document.createElement('div');
		element.innerHTML = markdown;
		const text = element.innerText;
		const result: FetchResult = {
			markdown,
			text,
		};
		return result;
	} catch (err) {
		console.error(`failed to fetch '${url}'`);
	}
}
